import { uniq } from 'lodash';

import cropsModule from 'domains/crops';
import canvases from 'domains/canvases';
import ui from 'domains/ui';
import photoModule from 'domains/photos';

import slice from './multiphotos.slice';

import { loadBlobAsImage } from 'utils/image_load';

import type { AppThunk } from 'store/wos_store';

export function moveCropsToMultiPhotos(photoIds: number[]): AppThunk {
  return function moveToMultiPhotosThunk(dispatch, getState) {
    const state = getState();
    const crops = cropsModule.selectors.selectAll(state);
    const cropPhotoIds = crops.map((crop) => crop.photoId);

    const ids = uniq([...cropPhotoIds, ...photoIds]);
    dispatch(slice.actions.addMultipleMultiPhotos(ids));

    ids.forEach((id) => {
      dispatch(createMultiPhotoCrop(id));
    });

    dispatch(cropsModule.actions.resetCrops());
    dispatch(canvases.actions.updateCanvas({ rotation: 0, userRotated: false }));
  };
}

export function createManyMultiPhotos(photoIds: number[]): AppThunk {
  return function createManyThunk(dispatch) {
    dispatch(slice.actions.addMultipleMultiPhotos(photoIds));

    photoIds.forEach((photoId) => {
      dispatch(createMultiPhotoCrop(photoId));
    });
  };
}

export function createMultiPhotoCrop(photoId: number): AppThunk {
  return async function createMultiPhotoThunk(dispatch, getState) {
    const state = getState();
    const photo = photoModule.selectors.selectById(state, photoId);

    if (!photo) return;

    dispatch(
      slice.actions.addMultiPhoto({
        id: photoId,
        photoId,
        photoLoaded: false,
      })
    );

    try {
      const image = await loadBlobAsImage(photo.file_path_1024);
      const { naturalWidth, naturalHeight } = image;

      const imageDimensions = { width: naturalWidth, height: naturalHeight };

      const cropData = {
        id: photoId,
        imageDimensions,
      };

      dispatch(slice.actions.addMultiPhotoCrop(cropData));
      URL.revokeObjectURL(image.src);
    } catch (error) {
      dispatch(
        ui.actions.setSiteMessage({
          enabled: true,
          messageType: 'error',
          message: 'Failed to load image. Remove images and try again.',
        })
      );
      dispatch(slice.actions.deleteMultiPhoto(photoId));
    }
  };
}
